// extracted by mini-css-extract-plugin
export var container = "MobileDrawer_container__hIiXO";
export var content = "MobileDrawer_content__9dMSe";
export var drawerHandle = "MobileDrawer_drawerHandle__23X1r";
export var modal = "MobileDrawer_modal__59YLZ";
export var popUpwards = "MobileDrawer_popUpwards__uT3GN";
export var swipeDown = "MobileDrawer_swipeDown__fU3qg";
export var swipedDown = "MobileDrawer_swipedDown__YRlWH";